import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface CountryParameter {
  code: number
  name: string
  type: string
}

export interface CountryParameterValue {
  countryParameterId: number
  appliesFrom: Date
  value: string
}

export async function getCountryParameters(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id=:countryId']
  if (search) {
    where.push(`CONCAT(code,name,type) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_country_parameters'],
    fields: ['id', 'code', 'name', 'type', 'last_applies_from'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getCountryParameter(
  id: string
): Promise<CountryParameter> {
  const data = await getData<any>({
    tables: ['pg_country_parameters'],
    fields: [
      'id',
      'country_id as countryId',
      'code',
      'name',
      'type',
      'last_applies_from'
      //'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function getCountryParameterValues(
  id: string
): Promise<CountryParameterValue> {
  const data = await getData<any>({
    tables: ['pg_country_parameter_values'],
    fields: [
      'country_parameter_id as countryParameterId',
      'applies_from as appliesFrom',
      'value as value'
    ],
    where: [`country_parameter_id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function updateCountryParameterValue(data: any): Promise<string> {
  const payload: any = []
  data.value.forEach((value: any) => {
    const action: any = {
      action: value.action
    }
    if (value.action === 'edited' || value.action === 'added') {
      action.countryParameterId = data.id
      action.appliesFrom = value.appliesFrom
      action.value = value.value
    }
    if (value.id) action.id = value.id
    payload.push(action)
  })
  const response: any = await http.post('country/parameters/bulk-values', {
    value: payload
  })

  for (const deleted in response?.data?.deleteResult) {
    if (response?.data?.deleteResult[deleted].includes('Error')) {
      const resp = response?.data?.deleteResult[deleted].split(':Error:')
      return JSON.parse(resp[1]).message
    }
  }
  for (const updated in response?.data?.updateResult) {
    if (response?.data?.updateResult[updated].includes('Error')) {
      const resp = response?.data?.updateResult[updated].split(':Error:')
      return JSON.parse(resp[1]).message
    }
  }
  for (const created in response?.data?.createResult) {
    if (response?.data?.createResult[created].includes('Error')) {
      const resp = response?.data?.createResult[created].split(':Error:')
      return JSON.parse(resp[1]).message
    }
  }

  return 'OK'
}
